// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iHsI","icon":"styles_icon__1-cxT"};